import { render, staticRenderFns } from "./AdvancedSalary.vue?vue&type=template&id=3f8c8e6f&"
import script from "./AdvancedSalary.vue?vue&type=script&lang=js&"
export * from "./AdvancedSalary.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedSalary.vue?vue&type=style&index=0&id=3f8c8e6f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports